export const GET_USER_TO_ASSETS = 'GET_USER_TO_ASSETS';

export const EXPORT_ASSET_BUYER_GQL_PENDING = 'EXPORT_ASSET_BUYER_GQL_PENDING';
export const GET_USER_TO_ASSETS_PENDING = 'GET_USER_TO_ASSETS_PENDING';
